import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box, Button, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

/**
 * Tek kutu arama.
 * trailing: search yanina ekstra kontrol (ornek: gorunum select)
 * placeholderKey: i18n anahtari (ornek: sales.search_placeholder)
 */
const EventListSearchBar = ({
  value = '',
  onSearch,
  onClear,
  disabled = false,
  trailing = null,
  placeholder,
  placeholderKey = 'form.search_placeholder',
}) => {
  const translate = useTranslate();
  const [draft, setDraft] = useState(value || '');

  useEffect(() => {
    setDraft(value || '');
  }, [value]);

  const resolvedPlaceholder =
    placeholder ||
    translate(placeholderKey, {
      _: 'Search by name, slug, venue, city or category…',
    });

  const handleSearch = () => {
    const cleaned = (draft || '')
      .replace(/[\u00a0\u2000-\u200b\u200c\u200d\ufeff]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    onSearch(cleaned);
  };

  const handleClear = () => {
    setDraft('');
    onClear();
  };

  const handleChange = (e) => {
    const next = e.target.value;
    setDraft(next);
    // Bosalinca Enter/Search beklemeden tum listeyi getir
    if (next.trim() === '' && (value || '').trim() !== '') {
      onClear();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        alignItems: 'center',
        mt: 2,
      }}
    >
      <TextField
        size="small"
        value={draft}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
          }
        }}
        placeholder={resolvedPlaceholder}
        disabled={disabled}
        sx={{ flex: 1, minWidth: 280, maxWidth: 520 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      <Button
        variant="contained"
        size="small"
        onClick={handleSearch}
        disabled={disabled}
        sx={{ minWidth: 90 }}
      >
        {translate('ra.action.search', { _: 'Search' })}
      </Button>
      <Button
        variant="outlined"
        size="small"
        onClick={handleClear}
        disabled={disabled || !draft}
        sx={{ minWidth: 80 }}
      >
        {translate('ra.action.clear_input_value', { _: 'Clear' })}
      </Button>
      {trailing}
    </Box>
  );
};

export default EventListSearchBar;
